module.exports = __webpack_public_path__ + "static/media/illustration.41758c87.png";